import Immutable from 'immutable';
import moment from "moment";

const LOAD = 'pay/LOAD';
const LOAD_WAIT = 'pay/LOAD_WAIT';
const LOAD_SUCCESS = 'pay/LOAD_SUCCESS';
const Patient_RESPONSE = 'pay/Patient_RESPONSE';
const LOAD_FAIL = 'pay/LOAD_FAIL';
const LOAD_FAIL_OTHER = 'pay/LOAD_FAIL_OTHER';
const SAVE_PARAMS_ORTHO = 'pay/SAVE_PARAMS_ORTHO'
const RESET_PAY_DATA = 'pay/RESET_PAY_DATA';
const LOAD_TRACK_CODES = 'pay/LOAD_TRACK_CODES'
const LOAD_TRACK_CODES_SUCCESS = 'pay/LOAD_TRACK_CODES_SUCCESS'

const initialState = Immutable.fromJS({
  isLoad: false,
  params: {
    startDate: moment().format('YYYY-MM-01'),
    showArchivedtrackCodes: false
  },
  billingData: {},
  patientResponse: false,
});


export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
          .set('isLoad', true)
          .set('loadErr', null);

    case LOAD_WAIT:
      return state
          .set('isLoad', false)
          .set('loadErr', null);

    case Patient_RESPONSE:
      return state
          .set('patientResponse', action.res)

    case SAVE_PARAMS_ORTHO:
      return state
          .set('params',action.params)

    case LOAD_FAIL_OTHER:
      return state
          .set('isLoad', false)
          .set('loadErr', action.error)

    case LOAD_SUCCESS:
      return state
          .set('loadErr', null)
          .set('billingData',  action.res)

    
    case RESET_PAY_DATA:
      return state
          .set('billingData',null)

    case LOAD_FAIL:
      return state
          .set('isLoad', false)
          .set('loadErr', action.error)
          .set('billingData', null)

    case LOAD_TRACK_CODES_SUCCESS:
      return state
          .set('trackCodes',action.res)
          .set('isLoad', false)

    case LOAD_TRACK_CODES:
      return state.set('isLoad', true)

    default:
      return state;
  }
};

export const getTimeOffRequestData = (filters) => async (dispatch, getState, api) => {}
export const deleteRampSetup = (reportObj) => async (dispatch, getState, api) => {}

export const getPayData = (params = '') => async (dispatch, getState, api) => {
  if(params){
    if(typeof(params)==='string'){
      const paramArray=params.split('&');
      params={startDate:paramArray[0].split('=')[1] , showArchivedtrackCodes:paramArray[1].split('=')[1]} 
    }
    dispatch( {type: SAVE_PARAMS_ORTHO, params: params})
  }
  dispatch({ type: LOAD });
  try {
    let payParams = new URLSearchParams(params).toString();
    const data = await api.get(`payReports/finalData/${payParams}`);
    dispatch({ type: LOAD_SUCCESS,  res: data });
    return data;

  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const updateParams = (month,year) => async (dispatch, getState, api) => {
  const params = getState().get('payReportsNDP').get('params');
  if(month === 'undo' || year === 'undo'){

  } else {
    params.startDate = moment(`${year}-${month}`, 'YYYY-MM').format('YYYY-MM-01')
  }

  dispatch( {type: SAVE_PARAMS_ORTHO, params: params})
}


export const getAllTrackCode = (params) => async (dispatch, getState, api) => {
  if(params){
    params = JSON.stringify(params)
  }
  if(!params){
    const startDate = moment(new Date(moment().startOf('month'))).format('Y-MM-01');
    params = {
      startDate: startDate,
      endDate: moment(new Date(moment().endOf('month'))).format('Y-MM-DD'),
      archive: false
    }
    params = JSON.stringify(params)
  }
  try {
    dispatch({ type: LOAD_TRACK_CODES });
    await api.get(`payReports/procedureCodeChanges/getAll/${params}`)
        .then(data => {
          dispatch({ type: LOAD_TRACK_CODES_SUCCESS, res: data });
        });

  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

// Fetch track codes from API without mutating redux store (returns data)
export const fetchAllTrackCodesRaw = (params) => async (dispatch, getState, api) => {
  try {
    if (params) params = JSON.stringify(params);
    else {
      const startDate = moment(new Date(moment().startOf('month'))).format('Y-MM-01');
      params = JSON.stringify({ startDate: startDate, endDate: moment(new Date(moment().endOf('month'))).format('Y-MM-DD'), archive: true });
    }
    const data = await api.get(`payReports/procedureCodeChanges/getAll/${params}`);
    return data;
  } catch (err) {
    throw err;
  }
};

export const addTrackCode = (reportObj) => async (dispatch, getState, api) => {
  if(reportObj && reportObj.procedureCode)
    reportObj.procedureCode = (reportObj.procedureCode).toUpperCase()
  try {
    dispatch({ type: LOAD_TRACK_CODES });
    await api.post('payReports/procedureCodeChanges/add', {data:reportObj})
        .then((data)=>{
          dispatch({type: Patient_RESPONSE, res: data})
          return;
        })

  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    throw err;
  }
};


export const updateTrackCode = (reportObj) => async (dispatch, getState, api) => {
  if(reportObj && reportObj.procedureCode)
    reportObj.procedureCode = (reportObj.procedureCode).toUpperCase()
  try {
    dispatch({ type: LOAD_TRACK_CODES });
    await api.post('payReports/procedureCodeChanges/update', {data:reportObj})
        .then((data)=>{
          dispatch({type: Patient_RESPONSE, res: data})
          return
        })
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    throw err;
  }
};

export const deleteTrackCode = (reportObj) => async (dispatch, getState, api) => {

  try {
    dispatch({ type: LOAD_TRACK_CODES });
    await api.post('payReports/procedureCodeChanges/delete', {data:reportObj})
        .then(() => {
          return
        })

  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    throw err;
  }
};


export const archiveTrackCode = (reportObj) => async (dispatch, getState, api) => {

  try {
    dispatch({ type: LOAD_TRACK_CODES });
    await api.post('payReports/procedureCodeChanges/archive', {data:reportObj})
        .then(() => {
          return
        })

  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    throw err;
  }
};

export const sendPayList = (payList, startDate) => async (dispatch, getState, api) => {
  try {
    dispatch({ type: LOAD });
    await api.post('payReports/sendPayList', {data: {payList: payList, startDate: startDate}})
        .then(() => {
          return
        })

  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
}

/**
 * Fetches the total Ortho (NDP) earnings for a given period.
 * Used by the CDP Reports combined pay popup.
 * Returns: { totalEarnings }
 */
export const getOrthoPayTotal = (params = '') => async (dispatch, getState, api) => {
  try {
    const data = await api.get(`payReports/getOrthoPayTotal/${params}`);
    return data;
  } catch (err) {
    console.error('[getOrthoPayTotal] failed:', err.message);
    return null;
  }
};

/**
 * Fetch pre-computed cross-report pay totals from database
 * Called by both CDP and Ortho Reports on initial load
 * Query params: startDate (YYYY-MM-01), endDate (YYYY-MM-DD) optional
 * Returns: { cdpPayDentist, cdpPayOralSurgeon, cdpPayPediatric, orthoPayTotal }
 */
export const getCrossReportTotals = (params = '') => async (dispatch, getState, api) => {
  try {
    const data = await api.get(`payReports/getCrossReportTotals${params ? '?' + params : ''}`);
    return data;
  } catch (err) {
    console.error('[getCrossReportTotals] failed:', err.message);
    return null;
  }
};

/**
 * Compute and persist all cross-report totals to database (called by cron job)
 * POST /payReports/computeAndSaveCrossReportTotals
 * Payload: { startDate: "YYYY-MM-01", endDate: "YYYY-MM-DD" }
 */
export const computeAndSaveCrossReportTotals = (dates) => async (dispatch, getState, api) => {
  try {
    const response = await api.post('payReports/computeAndSaveCrossReportTotals', dates);
    console.log('[computeAndSaveCrossReportTotals] saved successfully:', response);
    return response;
  } catch (err) {
    console.error('[computeAndSaveCrossReportTotals] failed:', err.message);
    return null;
  }
};